import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography } from '@mui/material';
const HtmlPlayer = ({ item, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
course, onEnd, }) => {
    const hasCalledOnEnd = useRef(false);
    const htmlContent = item.content?.html || '';
    useEffect(() => {
        // Mark as completed when HTML content is rendered
        if (htmlContent && !hasCalledOnEnd.current) {
            hasCalledOnEnd.current = true;
            onEnd();
        }
    }, [htmlContent, onEnd]);
    if (!htmlContent) {
        return (_jsx(Box, { sx: { p: 2 }, children: _jsx(Typography, { variant: "body1", color: "text.secondary", children: "No HTML content available." }) }));
    }
    return (_jsx(Box, { sx: { minHeight: '300px' }, children: _jsx(Box, { className: "mcn-html-lesson-content", sx: {
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                overflowX: 'auto',
                overflowY: 'visible',
                WebkitOverflowScrolling: 'touch',
                boxSizing: 'border-box',
            }, children: _jsx("div", { 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: { __html: htmlContent } }) }) }));
};
HtmlPlayer.defaultProps = {
    course: undefined,
};
export default observer(HtmlPlayer);
//# sourceMappingURL=HtmlPlayer.js.map